import { useEffect, useState } from "react";
import { Building2, Pencil, Plus, Trash2, Search } from "lucide-react";
import { toast } from "sonner";
import { api, money } from "../api";
import { useAuth } from "../auth";
import EntityEditModal from "../components/EntityEditModal";
import EmployerDetail from "./EmployerDetail";

export default function Employers() {
  const { can } = useAuth();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [modal, setModal] = useState(null); // null | {} (yeni) | item
  const [selected, setSelected] = useState(null);

  const load = () => api.get("/employers").then(r => setItems(r.data)).catch(() => toast.error("İşverenler yüklenemedi"));
  useEffect(() => { load(); }, []);
  const remove = async (id) => { if (window.confirm("Silinsin mi?")) { await api.delete(`/employers/${id}`); load(); } };

  const filtered = items.filter(e => !q || e.short_name?.toLowerCase().includes(q.toLowerCase()) || e.name?.toLowerCase().includes(q.toLowerCase()));

  if (selected) return <EmployerDetail id={selected} onBack={() => { setSelected(null); load(); }} />;

  return (
    <main className="content" data-testid="page-employers">
      <div className="page-head">
        <div>
          <span className="section-kicker">İŞVEREN PORTFÖYÜ</span>
          <h1>İşverenler ({items.length})</h1>
          <p>Karta tıklayın: firma bazında tüm projeler, tahsilat dökümü ve kalan bakiye. Fatura bilgilerini kalem simgesinden düzenleyin.</p>
        </div>
        {can("admin", "project_manager") && <button className="new-btn" onClick={() => setModal({})} data-testid="toggle-employer-form"><Plus size={17} /> Yeni İşveren</button>}
      </div>

      <div className="filter-bar">
        <div className="search-wrap"><Search size={15} /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="İşveren ara..." data-testid="employer-search" /></div>
      </div>

      <div className="card-grid" data-testid="employer-cards">
        {filtered.map((e) => (
          <div className="entity-card clickable" key={e.id} data-testid={`employer-card-${e.short_name}`} onClick={() => setSelected(e.id)}>
            <div className="entity-head">
              <div className="entity-badge"><Building2 size={16} /></div>
              <div><b>{e.short_name}</b><small>{e.name}</small></div>
              <div className="row-actions" onClick={(ev) => ev.stopPropagation()}>
                <button className="row-action" onClick={() => setModal(e)} data-testid={`edit-emp-${e.short_name}`}><Pencil size={13} /></button>
                {can("admin", "project_manager") && <button className="row-action danger" onClick={() => remove(e.id)} data-testid={`delete-emp-${e.short_name}`}><Trash2 size={13} /></button>}
              </div>
            </div>
            <div className="entity-stats">
              <span><small>PROJE</small><b>{e.project_count || 0}</b></span>
              <span><small>ANLAŞILAN</small><b>{money(e.total_agreed)}</b></span>
              <span><small>TAHSİLAT</small><b>{money(e.total_paid_by_employer)}</b></span>
            </div>
            <div className="entity-meta">
              {e.tax_no ? <span>Vergi: {e.tax_office || "—"} · {e.tax_no}</span> : <span className="missing">Fatura bilgisi eksik</span>}
              {(e.contact_person || e.phone) && <span>{e.contact_person}{e.phone ? ` · ${e.phone}` : ""}</span>}
            </div>
          </div>
        ))}
        {!filtered.length && <div className="empty-hint">İşveren bulunamadı.</div>}
      </div>
      {modal && <EntityEditModal kind="employer" item={modal.id ? modal : null} close={() => setModal(null)} onSaved={load} />}
    </main>
  );
}
